module.exports = __webpack_public_path__ + "static/media/embed.ce389ffa.webp";


//////////////////
// WEBPACK FOOTER
// ./src/containers/StartPages/embed.webp
// module id = 243
// module chunks = 1